import { ScrollableCardGrid } from 'components/molecules/ScrollableCardGrid';
import {
  ContentNavigationMultiple,
  ContentNavigationSingle,
  isContentNavigationSingle,
} from 'types/contentful/Items/ContentNavigationItem';

import { ContentNavigationCardMultiple } from '../molecules/ContentNavigationCardMultiple';
import { ContentNavigationCardSingle } from '../molecules/ContentNavigationCardSingle';

interface Props {
  contentNavigationItems: (
    | ContentNavigationMultiple
    | ContentNavigationSingle
  )[];
}

export const ContentNavigationList: React.FC<Props> = ({
  contentNavigationItems,
}) => (
  <section className="py-12 bg-black tablet:pt-18 laptop:pt-20 tablet:pb-18 laptop:pb-20">
    <div className="content-wrapper">
      <ScrollableCardGrid>
        {contentNavigationItems.map((item) =>
          isContentNavigationSingle(item) ? (
            <ContentNavigationCardSingle key={item.id} content={item} />
          ) : (
            <ContentNavigationCardMultiple key={item.id} content={item} />
          )
        )}
      </ScrollableCardGrid>
    </div>
  </section>
);
